import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import moment from 'moment'
import LANGUAGE from './utils/language/index'
// import IpubUi from './components/ipub-ui/src'
import IpubUi from 'ipubs-ui-vue'
import 'ipubs-ui-vue/lib/ipub-ui.css'

const $moment = Object.defineProperty(Vue.prototype, '$moment', {
  value: moment,
  writable: false
})

Vue.config.productionTip = false

Vue.use(IpubUi)
Vue.use($moment)
Vue.prototype.LANGUAGE = LANGUAGE

// router.beforeEach(async (to, from, next) => {
//   localStorage.setItem('preRoute', from.fullPath)
//   next()
// })
const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vm
